/**
 * What each role sees in the UI (#71). The backend enforces all of it (#69);
 * this only avoids showing buttons and pages that would answer 403.
 *   admin     : everything
 *   organizer : "Gestionnaire d'événements": assigned events, no Contacts / CRM / palette / accounts / demo
 *   viewer    : "Accueil" (front desk): assigned events list, check-in only
 */
export interface NavItem {
  label: string;
  path: string;
}

const isAdmin = (role?: string) => role === 'admin';

export const navItemsFor = (role?: string): NavItem[] => {
  if (role === 'viewer') return [{ label: 'Événements', path: '/events' }];
  const items: NavItem[] = [
    { label: 'Tableau de bord', path: '/' },
    { label: 'Événements', path: '/events' },
  ];
  if (isAdmin(role)) {
    items.push(
      { label: 'Contacts', path: '/contacts' },
      { label: 'CRM Sync', path: '/crm' },
      { label: 'Palette e-mails', path: '/settings/email-palette' },
      { label: 'Comptes', path: '/settings/accounts' },
    );
  }
  return items;
};

/** Where a user lands on "/": the front desk goes straight to its events. */
export const homePathFor = (role?: string): string => (role === 'viewer' ? '/events' : '/');

/** Front desk: no event editing, only the check-in entry point. */
export const isFrontDesk = (role?: string): boolean => role === 'viewer';
